import React from 'react';
// import { Navigate } from 'react-router-dom';
// import type { RouteObject } from 'react-router-dom';

import { Loader } from 'components/Loader';
import { props } from './props';

const { name } = props;
const List = React.lazy(() => import(`views/distributor/${name}/page/List`));
const Show = React.lazy(() => import(`views/distributor/${name}/page/Show`));
const Garant = React.lazy(() => import(`views/distributor/warranty/page/Garant`));

const routes: any[] = [
	{
		path: `/distributor/warranty`,
		element: (
			<React.Suspense fallback={<Loader />}>
				<Garant />
			</React.Suspense>
		),
    roles: ['distributor']

	},
	{
		path: `/${name}/:page`,
		element: (
			<React.Suspense fallback={<Loader />}>
				<List />
			</React.Suspense>
		),
    roles: ['distributor']

	},
	{
		path: `/distributor/${name}/show/:id`,
		element: (
			<React.Suspense fallback={<Loader />}>
				<Show />
			</React.Suspense>
		),
    roles: ['distributor']

	},
];

export default routes;
